  import React, { useContext, useEffect, useState } from 'react';

import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';
import DefaultModal from '../../components/default/DefaultModal';
import DefaultToolBar from '../../components/default/DefaultToolBar';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import { AppContext } from '../../contexts/AppContext';
import { PurchaseDocumentDataForm, PurchaseDocumentFilters } from '../../app/models/PurchaseDocument';
import { useHistory } from 'react-router-dom';
import PurchaseDocumentDataTable from './components/tables/PurchaseDocumentDataTable';
import useNavigationPage from '../../hooks/useNavigationPage';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import usePurchaseDocumentService from '../../app/services/hooks/usePurchaseDocumentService';
import { PurchaseDocumentStatus } from '../../app/models/PurchaseDocumentStatus';
import PurchaseDocumentCreate from './components/PurchaseDocumentCreate';
import NoteCreate from './components/NoteCreate';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Documentos de Compra',
        url: '/purchase-documents',
        isActive: true
    }
];

const PurchaseDocuments = () => {
    const { navigationPage } = useNavigationPage();
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingGetPurchaseDocuments, getPurchaseDocuments, deletePurchaseDocument, createPurchaseDocument} = usePurchaseDocumentService();
    //, activePurchaseDocument
    const [purchaseDocuments, setPurchaseDocuments] = useState<PurchaseDocumentDataForm[]>([]);
    const [statuses, setStatuses] = useState<PurchaseDocumentStatus[]>([]);


    const [purchaseDocumentIdEdit, setPurchaseDocumentIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingCreateNote, setShowingCreateNote] = useState(false);
    const [showingCreatePurchaseDocument, setShowingCreatePurchaseDocument] = useState(false);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [noteType, setNoteType] = useState<string | null>(null); 
    const [documentType, setDocumentType] = useState<string | null>(null); 

    const [purchaseDocumentFilter, setPurchaseDocumentFilter] = useState<PurchaseDocumentFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    useEffect(() => {
        reloadTable();
    }, [purchaseDocumentFilter]);

    const getAllPurchaseDocuments = () => {
        getPurchaseDocuments(purchaseDocumentFilter, {
            onSuccess: (response: ServiceResponse) => {
                setPurchaseDocuments(response.data.purchase_documents);
                setStatuses(response.data.statuses);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            }
        });
    };

    // const showEdit = (taxDocumentId: number) => {
    //     setShowingEdit(true);
    //     setPurchaseDocumentIdEdit(taxDocumentId);
    // };

    const showEdit = (id: number) => {
        navigationPage(`/purchase-documents/${id}/edit`);
    };

    const show = (id?: number) => {
        navigationPage(`/purchase-documents/${id}/show`);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setPurchaseDocumentIdEdit(-1);
    };

    const showCreatePurchaseDocument = () => {
        setShowingCreatePurchaseDocument(true);
    };

    const hideCreatePurchaseDocument = () => {
        setShowingCreatePurchaseDocument(false);
    };

    const showCreateNote = (type: string, docType: string) => {
        setNoteType(type);
        setDocumentType(docType);
        setShowingCreateNote(true);
    };
    
    const hideCreateNote = () => {
        setNoteType(null);
        setDocumentType(null);
        setShowingCreateNote(false);
    };

    // const showCreateCreditNote = () => {
    //     setShowingCreateCreditNote(true);
    // };

    // const hideCreateCreditNote = () => {
    //     setShowingCreateCreditNote(false);
    // };

    const reloadTable = () => {
        getAllPurchaseDocuments();
    };

    const onSavedRedirect = (data: any) => {
        const id = data?.purchase_document_id;
        if (id) {
            navigationPage(`/purchase-documents/${id}/edit`);
        } else {
            toast.error("Error: No se pudo obtener el ID del documento.");
        }
    };

    const destroy = (purchaseDocumentId: number) => {
        const _text = 'Está a punto de eliminar el documento de compra #' + purchaseDocumentId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando documento de venta...');
                        deletePurchaseDocument(purchaseDocumentId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El documento de venta no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    return (
        <>
            <Breadcrumbs pageSection="Documentos de Compra" breadcrumbs={breadcrumbs} />

            <DefaultCard>

                <div className="row">
                    <div className="col-12 mb-2">
                        <div className='row'>
                           <div className='col-auto'>
                            <ButtonCreate
                                title="Nueva Factura de Compra"
                                callbackCreate={showCreatePurchaseDocument}
                            />
                           </div>

                            {/* <div className='col-auto'>
                            <ButtonCreate
                                title="Nueva Nota de Credito"
                                callbackCreate={() => showCreateNote("Crédito", "NOTA_CREDITO")}
                            />
                            </div>

                            <div className='col-auto'>
                            <ButtonCreate
                                title="Nueva Nota de Debito"
                                callbackCreate={() => showCreateNote("Débito", "NOTA_DEBITO")}
                            />
                            </div> */}
                           
                        </div>
                        
                    </div>
                <div className="col-12">
                    <PurchaseDocumentDataTable
                        purchaseDocuments={purchaseDocuments}
                        statuses={statuses}
                        edit={showEdit}
                        show={show}
                        destroy={destroy}
                        loading={fetchingGetPurchaseDocuments}
                        filter={purchaseDocumentFilter}
                        setFilter={setPurchaseDocumentFilter}
                        totalRows={totalRows}
                        callbackSuccess={reloadTable}
                    />
                </div>
            </div>
            </DefaultCard>

            {showingCreatePurchaseDocument ? (
                <DefaultModal
                    show={showingCreatePurchaseDocument}
                    handleClose={hideCreatePurchaseDocument}
                    title="Crear Factura de compra"
                    backdrop={true}
                    showFooter={false}
                >
                    <PurchaseDocumentCreate
                        onSaved={(data) => {
                            reloadTable();
                            hideCreatePurchaseDocument();
                            onSavedRedirect(data);
                        }}
                        onCancel={hideCreatePurchaseDocument}
                        onError={hideCreatePurchaseDocument}
                    />
                </DefaultModal>
            ) : null}

            

            {showingCreateNote ? (
                <DefaultModal
                    show={showingCreateNote}
                    handleClose={hideCreateNote}
                    title={`Crear Nota de ${noteType}`}
                    backdrop={true}
                    showFooter={false}
                >
                    <NoteCreate
                        documentType={documentType}
                        onSaved={(data) => {
                            reloadTable();
                            hideCreateNote();
                            onSavedRedirect(data);
                        }}
                        onCancel={hideCreateNote}
                        onError={hideCreateNote}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default PurchaseDocuments;
